import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import DatePickerBottomSheet from '@di-shared/features/history/download/DatePickerBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

export function DatePickerPage() {
  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <DatePickerBottomSheet />
    </BottomSheetWebViewWrapper>
  );
}
